<p-toast></p-toast>
<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"
    [expanded]="panelOpenState()" id="main" class="border">
    <mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
      <div class="container-fluid"
        style="background: black;display: flex;align-items: center;justify-content: space-between;">

        <h5 class="mb-0 text-white">Reducer Results
        </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
        <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
      </div>
    </mat-expansion-panel-header>
    <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
      <div class="container-fluid"
        style="background: #e2001a;display: flex;align-items: center;justify-content: space-between;">

        <h5 class="mb-0 text-white">Reducer Results
        </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
        <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
      </div>
    </mat-expansion-panel-header>

    <div *ngIf="signalStatus==true">
      <div class="card">
        <div class="container-fluid justify-content-center">
          <div class="row border">
            <div class="row">
              <div class="col-lg-12">
                <div style="margin-top: 10px;margin-bottom: 10px;"><b>Product Code: {{productCode}}</b></div>
              </div>
            </div>
          </div>

          <div class="row">
            <input id="Btn_ChangeReducer" type="button" value="Reselect Reducer" class="button m-1"
              style="background-color: #C0C0C0; font-weight: bold;     margin-right: 0.5px !important; width: 19.5%;"
              (click)="scrollToCommonSecondComponent()">
            <input id="Btn_Reset" type="button" value="Restart Selection" class="button m-1"
              style="background-color: #C0C0C0; font-weight: bold;     margin-right: 0.5px !important; width: 19.5%;"
              (click)="scrollToCommonFirstComponent()">
            <input id="Btn_Spec" type="button" value="Download Spec" class="button m-1"
              style="background-color: #C0C0C0; font-weight: bold; margin-right: 3.5px !important;width: 19.5%;"
              (click)="DownloadSpec()">
            <input id="Btn_Quote" type="button" value="Request Quote" class="button m-1"
              style="background-color: #C0C0C0; font-weight: bold; margin-left: 0px !important; width: 19.5%;"
              (click)="RequestQuote()">
            <input id="Btn_Dimension" type="button" value="Download 2D Dimensioned PDF" class="button_big m-1"
              style="background-color: #C0C0C0; font-weight: bold;margin-left: 0px !important; width: 19.5%;"
              (click)="Download2DDimFile()">
            <!-- <input id="Btn_Dimension" type="button" value="Download 2D Dimensioned PDF" class="button_big m-1" style="background-color: #C0C0C0; font-weight: bold;margin-left: 0px !important; width: 19.5%;" (click)="Download2DDimFile()"> -->
          </div>



          <div class="row border">
            <div class="col-md-6 col-lg-6 border">
              <div class="row" id="cadGenerateArea">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" colspan="2">Select format to create the CAD files for download</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>

                      <td scope="row" style="border: none; width: 200px;">3D CAD file format:</td>
                      <td style="border: none;">
                        <select name="3d_CAD" id="3d_CAD" (change)="onCAD3DFileChange($event)">
                          <option value=".stp">STEP document(*.step,*.stp)</option>
                          <option value=".igs">IGES document(*.iges,*.igs)</option>
                          <option value=".x_t">Parasolid document(*.x_b,*.x_t)</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row" style="border: none; width: 200px;">2D CAD file format:</td>
                      <td style="border: none;">
                        <select name="2d_CAD" id="2d_CAD" (change)="onCAD2DFileChange($event)">
                          <option value=".dxf">AutoCAD document(*.dxf)</option>
                          <option value=".dgn">Microstation document(*.dgn)</option>
                          <option value=".dwg">AutoCAD document(*.dwg)</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <input id="Btn_CreateCAD" type="button" value="Create CAD" class="button custom-btn"
                          (click)="createCAD()">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row" style="display: none;" id="cadProcessArea">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" colspan="2">Automated CAD File Generation</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr>
                      <td style="text-align: center;">
                        <h3 class="text-info">Please wait while your request is being processed</h3>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: center;">
                        <img [src]=" AssetbasePath + '/images/MainImages/Loading.gif'" alt="Wait" /><br />
                        <p><strong>Generating files...</strong></p>
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: center;">
                        <h6 class="text-info">
                          <b>
                            Please wait while your files are generated.<br />
                            Please do not use the browser REFRESH or BACK buttons during this process - doing
                            so may not generate files correctly
                          </b>
                        </h6>

                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>
              <div class="row" style="display: none;" id="cadShownArea">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" colspan="2">CAD Preview and Drawing Files</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <p class="text-danger" style="font-weight: bolder;"><b>Note: If you are unable to view an active
                            3D PDF image, please use the button below to download the 3D PDF file and view with Adobe
                            Reader</b></p>
                      </td>

                    </tr>

                    <tr *ngIf="userLoginStatus != true">
                      <td colspan="2">
                        <input id="Btn_DrawingDownload" type="button"
                          value="Register to Download 3D Models and Drawings" class="button w-100"
                          (click)="showDrawingRegister()">
                      </td>
                    </tr>

                    <tr *ngIf="userLoginStatus == true">
                      <td colspan="2">
                        <input style="width:32%;margin-right:10px;" id="Btn_3DPDF" type="button" value="Download 3D PDF"
                          class="button custom-btn" (click)="download3DPDFWithStatus()">
                        <input style="width:32%;margin-right:10px;" id="Btn_3DFile" type="button"
                          value="Download 3D File" class="button custom-btn" (click)="download3DFileWithStatus()">
                        <input style="width: 32%;" id="Btn_2DFile" type="button" value="Download 2D File"
                          class="button custom-btn" (click)="download2DFileWithStatus()">
                      </td>

                    </tr>


                    <tr>
                      <!-- <td>
                            <img id="cadImage" class="img-fluid"/>
                        </td> -->
                      <td colspan="2">
                        <!-- <div *ngIf="!isImageLoaded" class="spinner">
                            <img src="../../../Powermate/assets/images/MainImages/Loading.gif" alt="Dowloading Please wait..." />
                          </div> -->
                        <!-- <img id="cadImage" class="img-fluid" *ngIf="isImageLoaded"/> -->
                        <img id="cadImage" class="img-fluid" />
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>


            </div>
            <table class="table table-bordered table-striped" id="userInput" hidden>
              <thead class="thead-dark">
                <tr>
                  <th scope="col">User Inputs</th>
                  <th scope="col">Values</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="row">Input Power</td>
                  <td>{{inputPower}}</td>
                </tr>
                <tr>
                  <td scope="row">Units</td>
                  <td style="text-transform: capitalize;">{{Units=='metric'?'Metric':'Imperial'}}</td>
                </tr>
                <tr>
                  <td scope="row">Input Speed</td>
                  <td>{{Speed}}</td>
                </tr>
                <tr>
                  <td scope="row">Ratio</td>
                  <td>{{Ratio}}</td>
                </tr>
                <tr>
                  <td scope="row">Duty Cycle greater than 50%</td>
                  <td>
                    {{ DutyCycle == 'yes' ? 'Yes' : 'No' }}
                  </td>

                </tr>
                <tr>
                  <td scope="row">Min Required Service Factor</td>
                  <td>{{ServiceFactor}}</td>
                </tr>
                <tr>
                  <td scope="row">Output Speed</td>
                  <td>{{OutputSpeed}}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6 col-lg-6 border">
              <table class="table table-bordered table-striped" id="specification">
                <thead class="thead-dark">

                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Values</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row">F</td>
                    <td>Series</td>
                  </tr>
                  <tr>
                    <td scope="row">{{modifiedSize}}</td>
                    <td>Size of Unit</td>
                  </tr>
                  <tr>
                    <td scope="row">1</td>
                    <td>Revision</td>
                  </tr>
                  <tr>
                    <td scope="row">{{specData.Ratio}}</td>
                    <td>Nominal Ratio</td>
                  </tr>

                  <tr>
                    <td scope="row">{{productDetails.typeOfUnitValue}}</td>
                    <td>{{productDetails.typeOfUnit}}</td>
                  </tr>
                  <tr>
                    <td scope="row">{{productDetails.unitversionValue}}</td>
                    <td>{{productDetails.unitversion}}</td>
                  </tr>
                  <tr *ngIf="productDetails.OutputShaft == 'Select for multiple inch bore options'">
                    <td scope="row">{{productDetails.boreDiaValue}}</td>
                    <td>Inch Hollow Shaft {{productDetails.boreDia}}</td>
                  </tr>
                  <tr *ngIf="productDetails.OutputShaft != 'Select for multiple inch bore options'">
                    <td scope="row">{{productDetails.OutputShaftValue}}</td>
                    <td>{{productDetails.OutputShaft}}</td>
                  </tr>
                  <tr *ngIf="productDetails.motorAdaptor == '--Select--'">
                    <td scope="row">-</td>
                    <td>Reducer Unit</td>
                  </tr>
                  <tr *ngIf="productDetails.motorAdaptor != '--Select--'">
                    <td scope="row">{{productDetails.motorAdaptorValue}}</td>
                    <td>{{productDetails.motorAdaptor}}</td>
                  </tr>
                  <tr>
                    <td scope="row">{{productDetails.assemblyPositionValue}}</td>
                    <td>{{productDetails.assemblyPosition}}</td>
                  </tr>
                  <tr>
                    <td scope="row">{{productDetails.specialFeatureValue}}</td>
                    <td>{{productDetails.specialFeature}}</td>
                  </tr>

                </tbody>
              </table>

            </div>


          </div>


          <!-- product specification -->

          <div class="row border">
            <div class="col-lg-12 col-md-12 col-sm-12 border">
              <table class="table table-bordered table-striped" id="specificationDetails">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Specification</th>
                    <th scope="col">Imperial</th>
                    <th scope="col">Metric</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row">Gearhead</td>
                    <td id="size">F</td>
                    <td>F</td>
                  </tr>
                  <tr>
                    <td scope="row">Size Of Unit</td>
                    <td id="size">{{modifiedSize}}</td>
                    <td>{{modifiedSize}}</td>
                  </tr>
                  <tr>
                    <td scope="row">Nominal Ratio</td>
                    <td id="ratio">{{specData.Ratio}}</td>
                    <td>{{specData.Ratio}}</td>
                  </tr>
                  <tr>
                    <td scope="row">Input Speed</td>
                    <td id="speed">{{specData.Speed}}</td>
                    <td>{{specData.Speed}}</td>
                  </tr>
                  <tr>
                    <td scope="row">Mechanical Input Power</td>
                    <td id="InpotPowerMechImp">{{specData.InputPower_Imp}}</td>
                    <td id="InputPowerMech_Met">{{specData.InputPower_Met}}</td>
                  </tr>
                  <tr>
                    <td scope="row">Thermal Input Power</td>
                    <td id="InputPowerThermalImp">{{specData.InputPower_Ther_Imp}}</td>
                    <td id="InputPowerThermal_Met">{{specData.InputPower_Ther_Met}}</td>
                  </tr>

                  <tr>
                    <td scope="row">Mechanical Output Torque</td>
                    <td id="InputTorque_Imp">{{specData.OutputTorque_Imp}}</td>
                    <td id="InputTorque_Met">{{specData.OutputTorque_Met}}</td>
                  </tr>

                  <tr>
                    <td scope="row">Efficiency</td>
                    <td id="EfficiencyImp">{{specData.EFF}}</td>
                    <td id="EfficiencyImp">{{specData.EFF}}</td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>



        </div>
      </div>


    </div>
    <div *ngIf="signalStatus==false">
      <h4 style="color: red;">Please proceed from previous step</h4>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div class="modal" id="commonRegisterModal" tabindex="-1" aria-labelledby="commonRegisterModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="commonRegisterModalLabel">User Information</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <form [formGroup]="userDetails">
          <div *ngIf="showEmailSearch" class="mb-3">
            <label for="searchEmail" class="form-label">Email Address</label>
            <div class="input-group">
              <input id="searchEmail" type="email" class="form-control" placeholder="Enter Your Email Address"
                [(ngModel)]="searchEmail" [ngModelOptions]="{standalone: true}" />
              <button type="button" class="btn btn-primary" (click)="searchByEmail()"
                [disabled]="!searchEmail || !searchEmail.trim()">Search</button>
              <button type="button" class="btn btn-secondary ms-2" (click)="clearEmailSearch()"
                *ngIf="searchEmail">Clear</button>
            </div>
            <div class="form-text text-muted" style="color: grey;">We found multiple profiles. Enter your email to
              auto-fill form.</div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <label for="fName" class="form-label">First Name</label>
              <input type="text" id="fName" class="form-control" placeholder="Enter First Name" formControlName="fName"
                #fNameField>
              <div *ngIf="userDetails.get('fName')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('fName')?.errors?.['required']">First name is required.</div>
                <div *ngIf="userDetails.get('fName')?.errors?.['pattern']">First name should contain only letters.</div>
              </div>


            </div>
            <div class="col-lg-6 col-md-6">
              <label for="lName" class="form-label">Last Name</label>
              <input type="text" class="form-control" id="lName" placeholder="Enter Last Name" formControlName="lName"
                #lNameField>
              <div *ngIf="userDetails.get('lName')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('lName')?.errors?.['required']">Last name is required.</div>
                <div *ngIf="userDetails.get('lName')?.errors?.['pattern']">Last name should contain only letters.</div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <label for="company" class="form-label">Company</label>
              <input type="text" class="form-control" id="company" placeholder="Enter Company" formControlName="company"
                #companyField>
              <div *ngIf="userDetails.get('company')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('company')?.errors?.['required']">Company name is required.</div>
                <div *ngIf="userDetails.get('company')?.errors?.['pattern']">Company name contains invalid characters.
                </div>
              </div>

            </div>
            <div class="col-lg-6 col-md-6">
              <label for="city" class="form-label">City</label>
              <input type="text" class="form-control" id="city" placeholder="Enter city" formControlName="city"
                #cityField>
              <div *ngIf="userDetails.get('city')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('city')?.errors?.['required']">City name is required.</div>
                <div *ngIf="userDetails.get('city')?.errors?.['pattern']">City name should contain only letters.</div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <label for="state" class="form-label">State</label>
              <input type="text" class="form-control" id="state" placeholder="Enter state" formControlName="state"
                #stateField>
              <div *ngIf="userDetails.get('state')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('state')?.errors?.['required']">State name is required.</div>
                <div *ngIf="userDetails.get('state')?.errors?.['pattern']">State name should contain only letters.</div>
              </div>


            </div>
            <div class="col-lg-6 col-md-6">
              <label for="country" class="form-label">Country</label>
              <div class="custom-select-wrapper">
                <select class="form-control" id="country" formControlName="country" #countryField>
                  <option value="" disabled>Select country</option> <!-- Placeholder -->
                  <<option value="USA">United States</option>
                    <option value="" disabled="disabled">----</option>
                    <option value="AFG">Afghanistan</option>
                    <option value="ALA">Åland Islands</option>
                    <option value="ALB">Albania</option>
                    <option value="DZA">Algeria</option>
                    <option value="ASM">American Samoa</option>
                    <option value="AND">Andorra</option>
                    <option value="AGO">Angola</option>
                    <option value="AIA">Anguilla</option>
                    <option value="ATA">Antarctica</option>
                    <option value="ATG">Antigua and Barbuda</option>
                    <option value="ARG">Argentina</option>
                    <option value="ARM">Armenia</option>
                    <option value="ABW">Aruba</option>
                    <option value="AUS">Australia</option>
                    <option value="AUT">Austria</option>
                    <option value="AZE">Azerbaijan</option>
                    <option value="BHS">Bahamas</option>
                    <option value="BHR">Bahrain</option>
                    <option value="BGD">Bangladesh</option>
                    <option value="BRB">Barbados</option>
                    <option value="BLR">Belarus</option>
                    <option value="BEL">Belgium</option>
                    <option value="BLZ">Belize</option>
                    <option value="BEN">Benin</option>
                    <option value="BMU">Bermuda</option>
                    <option value="BTN">Bhutan</option>
                    <option value="BOL">Bolivia, Plurinational State of</option>
                    <option value="BES">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BIH">Bosnia and Herzegovina</option>
                    <option value="BWA">Botswana</option>
                    <option value="BVT">Bouvet Island</option>
                    <option value="BRA">Brazil</option>
                    <option value="IOT">British Indian Ocean Territory</option>
                    <option value="BRN">Brunei Darussalam</option>
                    <option value="BGR">Bulgaria</option>
                    <option value="BFA">Burkina Faso</option>
                    <option value="BDI">Burundi</option>
                    <option value="KHM">Cambodia</option>
                    <option value="CMR">Cameroon</option>
                    <option value="CAN">Canada</option>
                    <option value="CPV">Cape Verde</option>
                    <option value="CYM">Cayman Islands</option>
                    <option value="CAF">Central African Republic</option>
                    <option value="TCD">Chad</option>
                    <option value="CHL">Chile</option>
                    <option value="CHN">China</option>
                    <option value="CXR">Christmas Island</option>
                    <option value="CCK">Cocos (Keeling) Islands</option>
                    <option value="COL">Colombia</option>
                    <option value="COM">Comoros</option>
                    <option value="COG">Congo</option>
                    <option value="COD">Congo, the Democratic Republic of the</option>
                    <option value="COK">Cook Islands</option>
                    <option value="CRI">Costa Rica</option>
                    <option value="CIV">Côte d'Ivoire</option>
                    <option value="HRV">Croatia</option>
                    <option value="CUB">Cuba</option>
                    <option value="CUW">Curaçao</option>
                    <option value="CYP">Cyprus</option>
                    <option value="CZE">Czech Republic</option>
                    <option value="DNK">Denmark</option>
                    <option value="DJI">Djibouti</option>
                    <option value="DMA">Dominica</option>
                    <option value="DOM">Dominican Republic</option>
                    <option value="ECU">Ecuador</option>
                    <option value="EGY">Egypt</option>
                    <option value="SLV">El Salvador</option>
                    <option value="GNQ">Equatorial Guinea</option>
                    <option value="ERI">Eritrea</option>
                    <option value="EST">Estonia</option>
                    <option value="ETH">Ethiopia</option>
                    <option value="FLK">Falkland Islands (Malvinas)</option>
                    <option value="FRO">Faroe Islands</option>
                    <option value="FJI">Fiji</option>
                    <option value="FIN">Finland</option>
                    <option value="FRA">France</option>
                    <option value="GUF">French Guiana</option>
                    <option value="PYF">French Polynesia</option>
                    <option value="ATF">French Southern Territories</option>
                    <option value="GAB">Gabon</option>
                    <option value="GMB">Gambia</option>
                    <option value="GEO">Georgia</option>
                    <option value="DEU">Germany</option>
                    <option value="GHA">Ghana</option>
                    <option value="GIB">Gibraltar</option>
                    <option value="GRC">Greece</option>
                    <option value="GRL">Greenland</option>
                    <option value="GRD">Grenada</option>
                    <option value="GLP">Guadeloupe</option>
                    <option value="GUM">Guam</option>
                    <option value="GTM">Guatemala</option>
                    <option value="GGY">Guernsey</option>
                    <option value="GIN">Guinea</option>
                    <option value="GNB">Guinea-Bissau</option>
                    <option value="GUY">Guyana</option>
                    <option value="HTI">Haiti</option>
                    <option value="HMD">Heard Island and McDonald Islands</option>
                    <option value="VAT">Holy See (Vatican City State)</option>
                    <option value="HND">Honduras</option>
                    <option value="HKG">Hong Kong</option>
                    <option value="HUN">Hungary</option>
                    <option value="ISL">Iceland</option>
                    <option value="IND">India</option>
                    <option value="IDN">Indonesia</option>
                    <option value="IRN">Iran, Islamic Republic of</option>
                    <option value="IRQ">Iraq</option>
                    <option value="IRL">Ireland</option>
                    <option value="IMN">Isle of Man</option>
                    <option value="ISR">Israel</option>
                    <option value="ITA">Italy</option>
                    <option value="JAM">Jamaica</option>
                    <option value="JPN">Japan</option>
                    <option value="JEY">Jersey</option>
                    <option value="JOR">Jordan</option>
                    <option value="KAZ">Kazakhstan</option>
                    <option value="KEN">Kenya</option>
                    <option value="KIR">Kiribati</option>
                    <option value="PRK">Korea, Democratic People's Republic of</option>
                    <option value="KOR">Korea, Republic of</option>
                    <option value="KWT">Kuwait</option>
                    <option value="KGZ">Kyrgyzstan</option>
                    <option value="LAO">Lao People's Democratic Republic</option>
                    <option value="LVA">Latvia</option>
                    <option value="LBN">Lebanon</option>
                    <option value="LSO">Lesotho</option>
                    <option value="LBR">Liberia</option>
                    <option value="LBY">Libya</option>
                    <option value="LIE">Liechtenstein</option>
                    <option value="LTU">Lithuania</option>
                    <option value="LUX">Luxembourg</option>
                    <option value="MAC">Macao</option>
                    <option value="MKD">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MDG">Madagascar</option>
                    <option value="MWI">Malawi</option>
                    <option value="MYS">Malaysia</option>
                    <option value="MDV">Maldives</option>
                    <option value="MLI">Mali</option>
                    <option value="MLT">Malta</option>
                    <option value="MHL">Marshall Islands</option>
                    <option value="MTQ">Martinique</option>
                    <option value="MRT">Mauritania</option>
                    <option value="MUS">Mauritius</option>
                    <option value="MYT">Mayotte</option>
                    <option value="MEX">Mexico</option>
                    <option value="FSM">Micronesia, Federated States of</option>
                    <option value="MDA">Moldova, Republic of</option>
                    <option value="MCO">Monaco</option>
                    <option value="MNG">Mongolia</option>
                    <option value="MNE">Montenegro</option>
                    <option value="MSR">Montserrat</option>
                    <option value="MAR">Morocco</option>
                    <option value="MOZ">Mozambique</option>
                    <option value="MMR">Myanmar</option>
                    <option value="NAM">Namibia</option>
                    <option value="NRU">Nauru</option>
                    <option value="NPL">Nepal</option>
                    <option value="NLD">Netherlands</option>
                    <option value="NCL">New Caledonia</option>
                    <option value="NZL">New Zealand</option>
                    <option value="NIC">Nicaragua</option>
                    <option value="NER">Niger</option>
                    <option value="NGA">Nigeria</option>
                    <option value="NIU">Niue</option>
                    <option value="NFK">Norfolk Island</option>
                    <option value="MNP">Northern Mariana Islands</option>
                    <option value="NOR">Norway</option>
                    <option value="OMN">Oman</option>
                    <option value="PAK">Pakistan</option>
                    <option value="PLW">Palau</option>
                    <option value="PSE">Palestinian Territory, Occupied</option>
                    <option value="PAN">Panama</option>
                    <option value="PNG">Papua New Guinea</option>
                    <option value="PRY">Paraguay</option>
                    <option value="PER">Peru</option>
                    <option value="PHL">Philippines</option>
                    <option value="PCN">Pitcairn</option>
                    <option value="POL">Poland</option>
                    <option value="PRT">Portugal</option>
                    <option value="PRI">Puerto Rico</option>
                    <option value="QAT">Qatar</option>
                    <option value="REU">Réunion</option>
                    <option value="ROU">Romania</option>
                    <option value="RUS">Russian Federation</option>
                    <option value="RWA">Rwanda</option>
                    <option value="BLM">Saint Barthélemy</option>
                    <option value="SHN">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KNA">Saint Kitts and Nevis</option>
                    <option value="LCA">Saint Lucia</option>
                    <option value="MAF">Saint Martin (French part)</option>
                    <option value="SPM">Saint Pierre and Miquelon</option>
                    <option value="VCT">Saint Vincent and the Grenadines</option>
                    <option value="WSM">Samoa</option>
                    <option value="SMR">San Marino</option>
                    <option value="STP">Sao Tome and Principe</option>
                    <option value="SAU">Saudi Arabia</option>
                    <option value="SEN">Senegal</option>
                    <option value="SRB">Serbia</option>
                    <option value="SYC">Seychelles</option>
                    <option value="SLE">Sierra Leone</option>
                    <option value="SGP">Singapore</option>
                    <option value="SXM">Sint Maarten (Dutch part)</option>
                    <option value="SVK">Slovakia</option>
                    <option value="SVN">Slovenia</option>
                    <option value="SLB">Solomon Islands</option>
                    <option value="SOM">Somalia</option>
                    <option value="ZAF">South Africa</option>
                    <option value="SGS">South Georgia and the South Sandwich Islands</option>
                    <option value="SSD">South Sudan</option>
                    <option value="ESP">Spain</option>
                    <option value="LKA">Sri Lanka</option>
                    <option value="SDN">Sudan</option>
                    <option value="SUR">Suriname</option>
                    <option value="SJM">Svalbard and Jan Mayen</option>
                    <option value="SWZ">Swaziland</option>
                    <option value="SWE">Sweden</option>
                    <option value="CHE">Switzerland</option>
                    <option value="SYR">Syrian Arab Republic</option>
                    <option value="TWN">Taiwan, Province of China</option>
                    <option value="TJK">Tajikistan</option>
                    <option value="TZA">Tanzania, United Republic of</option>
                    <option value="THA">Thailand</option>
                    <option value="TLS">Timor-Leste</option>
                    <option value="TGO">Togo</option>
                    <option value="TKL">Tokelau</option>
                    <option value="TON">Tonga</option>
                    <option value="TTO">Trinidad and Tobago</option>
                    <option value="TUN">Tunisia</option>
                    <option value="TUR">Turkey</option>
                    <option value="TKM">Turkmenistan</option>
                    <option value="TCA">Turks and Caicos Islands</option>
                    <option value="TUV">Tuvalu</option>
                    <option value="UGA">Uganda</option>
                    <option value="UKR">Ukraine</option>
                    <option value="ARE">United Arab Emirates</option>
                    <option value="GBR">United Kingdom</option>
                    <option value="UMI">United States Minor Outlying Islands</option>
                    <option value="URY">Uruguay</option>
                    <option value="UZB">Uzbekistan</option>
                    <option value="VUT">Vanuatu</option>
                    <option value="VEN">Venezuela, Bolivarian Republic of</option>
                    <option value="VNM">Viet Nam</option>
                    <option value="VGB">Virgin Islands, British</option>
                    <option value="VIR">Virgin Islands, U.S.</option>
                    <option value="WLF">Wallis and Futuna</option>
                    <option value="ESH">Western Sahara</option>
                    <option value="YEM">Yemen</option>
                    <option value="ZMB">Zambia</option>
                    <option value="ZWE">Zimbabwe</option>
                </select>
              </div>
              <div *ngIf="userDetails.get('country')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('country')?.errors?.['required']">Country name is required.</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <label for="email" class="form-label">Email</label>
              <input type="email" class="form-control" id="email" placeholder="Enter email" formControlName="email"
                #emailField>
              <div *ngIf="userDetails.get('email')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('email')?.errors?.['required']">Email is required.</div>
                <div *ngIf="userDetails.get('email')?.errors?.['email']">Please enter a valid email address.</div>
              </div>

            </div>
            <div class="col-lg-6 col-md-6">
              <label for="lName" class="form-label">Phone Number</label>
              <input type="text" class="form-control" id="phone" placeholder="Enter phone number"
                formControlName="phone" #phoneField>
              <div *ngIf="userDetails.get('phone')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('phone')?.errors?.['required']">Phone number is required.</div>
                <div *ngIf="userDetails.get('phone')?.errors?.['pattern']">Please enter valid phone number.</div>
              </div>

            </div>
          </div>
          <div class="row" *ngIf="fileType=='requestQuote'">
            <div class="col-lg-6 col-md-6">
              <label for="quantity" class="form-label">Quantity</label>
              <input type="number" class="form-control" id="quantity" value="1" placeholder="Enter quantity"
                formControlName="quantity" #quantityField>
              <!-- <div *ngIf="formSubmitted && (!quantityField.value || quantityField.value.trim() === '')" class="text-danger">
                      Please enter valid quantity.
                    </div> -->
              <div *ngIf="userDetails.get('quantity')?.invalid && formSubmitted" class="text-danger">
                <div *ngIf="userDetails.get('quantity')?.errors?.['min']">Quantity must be at least 1.</div>
              </div>

            </div>
            <div class="col-lg-6 col-md-6">
              <label for="comment" class="form-label">Comments</label>
              <input type="text" class="form-control" id="comment" placeholder="Enter comments"
                formControlName="comment" #commentField>
              <div *ngIf="formSubmitted && (!commentField.value || commentField.value.trim() === '')"
                class="text-danger">
                Please enter valid comments.
              </div>
            </div>
          </div>
          <div class="mb-3">


            <!-- <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> -->
          </div>
          <!-- <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">Password</label>
                <input type="password" class="form-control" id="exampleInputPassword1">
              </div> -->
          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="policyCheck" formControlName="policyCheck" #policyCheck>
            <label class="form-check-label" for="policyCheck">
              I have read and agree to the <a href="https://www.timken.com/privacy-statement/" target="_blank"
                style="text-decoration: underline;">Privacy Policy</a>, <a href="https://www.timken.com/terms-of-use/"
                target="_blank" style="text-decoration: underline;">Terms of Service</a>, and the <button
                id="PrivacyLinkButton"
                style="background: none; border: none; color: #007bff; text-decoration: underline; cursor: pointer;"
                (click)="showRegisterForm()">Terms and Conditions</button>
              <!-- I have read and agree to the <a href="https://www.timken.com/privacy-statement/" target="_blank" style="text-decoration: underline;">Privacy Policy</a>, <a href="https://www.timken.com/terms-of-use/" target="_blank" style="text-decoration: underline;">Terms of Service</a>, and the <a href="#" id="PrivacyLink" style="text-decoration: underline;" (click)="testpop();$event.preventDefault();">applicable terms and conditions</a>. -->
            </label>
          </div>
          <div *ngIf="formSubmitted && !policyCheck.checked" class="text-danger">
            You must agree to the terms and conditions.
          </div>

          <!-- <button type="submit" class="btn btn-primary">Submit</button> -->
        </form>

      </div>
      <div class="modal-footer">
        <button type="button" id="closeRegisterModal" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="closeRegisterModal()">Close</button>
        <button id="processSubmit" type="button" class="btn btn-primary" (click)="processSubmit()">Submit</button>
      </div>
    </div>
  </div>
</div>


<!-- Here is the pop up for Request Quote -->


<div class="modal fade" id="sendQuoteModal" tabindex="-1" aria-labelledby="sendQuoteModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="sendQuoteModalLabel">Please Specify Quantity & Comments</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="requestDetails">
          <div class="input-group">
            <span class="input-group-text" style="width: 102px;">Quantity</span>
            <input type="number" aria-label="Quantity" id="requestQuantity" value="1" class="form-control"
              formControlName="requestQuantity" #requestQuantityField>
          </div>
          <div *ngIf="requestFormSubmitted && (!requestQuantityField.value || requestQuantityField.value.trim() === '')"
            class="text-danger">
            Please enter valid quantity.
          </div>
          <br>
          <div class="input-group">
            <span class="input-group-text">Comments</span>
            <textarea class="form-control" aria-label="With textarea" id="requestComments"
              formControlName="requestComments" #requestCommentsField placeholder="Optional Comments"></textarea>
          </div>
        </form>


        <!-- <p-button type="button" pRipple (click)="showSuccess()" label="Success" severity="success">Test</p-button> -->



      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="processQuoteSubmit()">Send
          Request Quote</button>
      </div>
    </div>
  </div>
</div>
<p-toast position="bottom-center" key="confirm" (onClose)="onReject()" [baseZIndex]="5000">
  <ng-template let-message #message>
    <div class="flex flex-col items-start flex-auto">
      <div class="flex items-center gap-2">
        <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" shape="circle" />
        <span class="font-bold">
          Amy Elsner
        </span>
      </div>
      <div class="font-medium text-lg my-4">
        {{ message.summary }}
      </div>
      <p-button severity="success" size="small" label="Reply" (click)="onConfirm()" />
    </div>
  </ng-template>
</p-toast>

<!-- Modal -->
<div class="modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Terms and Conditions</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closePrivacyModal()"></button>
      </div>
      <div *ngIf="showcdinfo" class="modal-body">
        <label class="form-check-label" for="policyCheck">
          By clicking Submit, you consent to the personal information you provide being used in the manner as described
          in our Privacy Notice, including access to that information by Cone Drive personnel who may be located outside
          your home country. In addition, you agree that the CAD drawings are for your personal, one-time use only, and
          that you will not modify or create any compilation or derivative work using the CAD drawings or distribute or
          display the CAD drawings on any website or other media.
        </label>
      </div>
      <div *ngIf="showspinfo" class="modal-body">
        <label class="form-check-label" for="policyCheck">
          By clicking Submit, you consent to the personal information you provide being used in the manner as described
          in our Privacy Notice, including access to that information by SPINEA personnel who may be located outside
          your home country. In addition, you agree that the CAD drawings are for your personal, one-time use only, and
          that you will not modify or create any compilation or derivative work using the CAD drawings or distribute or
          display the CAD drawings on any website or other media.
        </label>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="closePrivacyModal()">Close</button>
        <button type="button" class="btn btn-primary" (click)="PrivacySubmit()">Submit</button>
      </div>
    </div>
  </div>
</div>